<template>
    <DnIcon
        class="base-icon"
    >
        <template
            v-for="name of Object.keys($slots)"
            v-slot:[name]="scope"
        >
            <slot
                :name="name"
                v-bind="scope"
            />
        </template>
    </DnIcon>
</template>

<script setup>
import DnIcon from '@digitalnatives/icon';
// import iconComponents from './icons';

// export default {
//     // The iconComponents below will lazily load *all* svg files in /assets/img/icons into this component
//     // Use them by passing the correct icon prop to this component.
//     components: iconComponents,
//     extends: DnIcon
// };
</script>
